import { observer } from "mobx-react"
import React, { Component } from "react"
import { Button, Icon, Input, Segment } from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import _ from "lodash"
import { Link } from "react-router-dom"
import Price from "components/Price/Price"
import ButtonLove from "components/Button/ButtonLove"
import { Label } from "semantic-ui-react"
import OrderModel from "shop/OrderModel";
import ImageWithFallback from "components/ImageWithFallback"

let orders = []
let ordersWithOpenPositions = []
let openPositions = []
let current = 0

@observer
export default class ProductListItem extends Component {

	state = {
		session: shop.session || {}, locations: [], showAddressBook: false, noMoreOrders: false, orderOpen: [], maxOrders: 5, maxOpenOrders: 5
	}

	loadSession = (session) => {
		this.setState({ noMoreOrders: false })
	}
	componentDidMount() {
		orders = []
		ordersWithOpenPositions = []
		openPositions = []
		current = 0
		shop.events.authentified.add(this.loadSession)
		// this.loadSession()
	}

	render() {
		let { product, index, categoryId = "", to = "/", search = "", currentOffset } = this.props
		if (!product) return <div>NO PRODUCT</div>
		let configByCategory = cmsStore.config.orthoFieldConfigByCategory[String(product.category && product.category.map_id)]

		let isDefaultConfig = false
		if (!configByCategory) {
			isDefaultConfig = true
			configByCategory = cmsStore.config.orthoFieldConfigByCategory["DEFAULT"]
		}
		const columnChunks = _.chunk(configByCategory.columns, 1)
		const inCart = shop.cart.productsById.get(product.map_id) || product
		console.log("LOCATION OFFSET IN LIST ITEM", currentOffset)


		return (
			<React.Fragment>
				<Segment attached={"bottom"} className="product db pv4 w-100 ProductListItem relative">
					<div className="flex flex-row w-100 items-center justify-between">
						<div className="flex flex-row w-60">
							<div className="badges absolute left-1 top-1 ">
								{product.extras && product.extras.neuheit && product.extras.neuheit.value && product.extras.neuheit.value.value && <span className="labelNeu1">&nbsp;&nbsp;{translate("Neu")}&nbsp;&nbsp;</span>}
								{product.pinfos && product.pinfos.rabatt && product.pinfos.rabatt < 0 && <span className="labelRabatt">&nbsp;&nbsp;{product.pinfos.rabatt + '%'}&nbsp;&nbsp;</span>}
							</div>
							<div className="badges absolute right-0 top-0 ">
								{shop.session && <ButtonLove list={shop.orderlist.default} Q
									className="dib mr3"
									elementInActive={<span><Icon name={"heart outline"} /></span>}
									elementActive={<span><Icon name={"heart"} /></span>}
									product={product} />}
							</div>
							{<ImageWithFallback
								style={{ maxWidth: "90px", maxHeight: "90px", minWidth: "90px", minHeight: "90px", overflow: "hidden", objectFit: "contain", transition: "opacity 0.3s" }}
								fallback="/image/placeholder.png"
								src={product.img_src_medium}
								alt={product.title}
								className="product-image pr2"
							/>}
							<div className={"flex flex-row items-center w-100 justify-left columnChunkContainer"}>
								<Link
									className="pr3 title-segment"
									to={{
										pathname: `${to}product/${product.map_id}/`,
										search
									}}>
									{/*<ImageWithFallback*/}
									{/*	width={45}*/}
									{/*	fallback={"/image/placeholder.png"}*/}
									{/*	className="img-responsive"*/}
									{/*	src={product.img_src_small} />*/}

									<div className={""}>
										<div className={"b f6 f5-ns nowrap flex"}>{product.article_nr} {shop.session && <span className="pl2">{product.getNotice("tiny")}</span>}</div>
										<div className={"f7 f6-ns mw8 w-100"} key={product.map_id + "desc"}>{product.desc.short_des}</div>
										<div className={"flex flex-row flex-wrap "}>
											<div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${"VE"}-${index}`}>
												<div title={"VE"} className={"f7 black-60 mw5 truncate "}>{translate("VE")}</div>
												<div title={"VE"} className={"f6 nowrap mw5 truncate"}>{product.smallestQuantity.multi} {translate("Stück")}</div>
											</div>
										</div>
									</div>
								</Link>
							</div>
						</div>

						<React.Fragment>
							{!shop.session && <div>
								<Button as={Link} basic className={"f6 nowrap"} to={`/login/?referrer=/product/${product.map_id}/`}>{translate("Preise anzeigen")}</Button>
							</div>}
							{shop.session && <ProductQuantitySimple product={product} inCart={inCart} />}
						</React.Fragment>
					</div >

					{/*<div className="dn db-ns pt2 ">
						<div className={"flex flex-row flex-wrap "}>


							{columnChunks.map((tuple, index) => {
								return <div key={`${index}`} className={""}>
									{tuple
										.filter((columnKey, subIndex) => {
											let fieldValue = product.extras[columnKey]
											switch (columnKey) {
												case "ArtikelNrLAG":
												case "Bezeichnung1":
												case "Verpackung":
												case "Bestell-Menge":
												case "Z_Verpackungseinheit_Anzahl":
												case "Preis":
												case "":
													return false

												default:
													if (!fieldValue) return null
													return true
											}
										})
										.map((columnKey, subIndex) => {
											let value
											let fieldValue = product.extras[columnKey]
											const columnDisplayName = fieldValue && fieldValue.text
											const displayValue = fieldValue && fieldValue.value && fieldValue.value.text

											switch (columnKey) {
												case "ArtikelNrLAG":
													value = null
													break;
												case "Bezeichnung1":
													value = null
													break;
												case "Verpackung":
													value = null
													break;
												case "Bestell-Menge":
													value = null
													break;
												case "Z_Verpackungseinheit_Anzahl":
													value = null
													break;
												case "Preis":
													value = null
													break;

												case "":
													value = null
													break;

												default:
													if (!fieldValue) return null
													value = <div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${subIndex}-${index}`}>
														<div title={columnDisplayName} className={"f7 black-80 mw5 truncate"}>{translate(columnDisplayName) || columnKey}</div>
														<div title={displayValue} className={"f6 nowrap mw5 truncate"}>{translate(displayValue) || <span className="red">N.A.</span>}</div>
													</div>
													break;
											}
											return value
										})}
								</div>
							})}
							<div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${"VE"}-${index}`}>
								<div title={"VE"} className={"f7 black-60 mw5 truncate "}>VE</div>
								<div title={"VE"} className={"f6 nowrap mw5 truncate"}>{product.smallestQuantity.multi} {translate("Stück")}</div>
							</div>

							<div className={"pr3 f6 tuples lh-title ttu pr4-ns"} key={`columnKey-${"DELIVERY"}-${index}`}>
								<div title={"VE"} className={"f7 black-60 mw5 truncate"}>{translate("Lieferzeit")}</div>
								<div title={"VE"} className={"f6 nowrap mw5 truncate"}>{translate(product.getNotice())} </div>
							</div>
						</div>
					</div>*/}
				</Segment >
			</React.Fragment >
		)
	}
}

function ProductQuantitySimple({ product, inCart = {} }) {
	const [count, setCount] = React.useState(inCart && inCart.count || 0)
	const [isDirty, setDirty] = React.useState(false)
	const [isLoading, setLoading] = React.useState(false)
	const same = count === inCart.count
	React.useEffect(() => {
		if (isDirty) return // so the input doesnt overwrite user inputted data
		if (inCart.count > 0) setCount(inCart.count)
		else setCount(1)
	}, [product, inCart])
	return <div className={"flex flex-wrap justify-end w-40"}>
		<div className="pr3 nowrap" style={{minWidth:"100px"}}>
			{product.isSale &&
				<div className="">
					<span className="f5 black-60 strike"><Price>{product.pinfos.brutto}</Price></span> <br />
					<span className="f5 red b"><Price>{product.price}</Price></span>
				</div>}
			{!product.isSale &&
				<div className="">
					<span className="f5  b"><Price>{product.price}</Price></span>
				</div>}
			{/*<Price>{product.price}</Price>*/}
			{/*inCart.count == 0 && <div className={"f6 black-80 nowrap"}>1 {translate("VE")} {product.unit_multi} {translate("Stk")}</div>*/}
			{count > 0 && <div className={"f6 black-80 nowrap"}>{count} {translate("VE")} {count * inCart.unit_multi} {translate("Stk")}</div>}
		</div>
		<div className={"ProductQuantitySimple flex flex-row items-center"}>
			<div className={"pr2"} style={{ width: "80px" }}><Input onChange={e => {
				setCount(e.currentTarget.value)
				setDirty(true)
			}} value={count} fluid type={"number"} min={0} /></div>
			<Button
				primary
				loading={isLoading}
				icon={same ? "shopping cart" : "plus"}
				onClick={async () => {
					let n = count

					if (!n) {
						n = 1
					} else {
						if (same) return
					}

					setLoading(true)
					product.count = n
					shop.cart.add(product)
					setDirty(false)
					await delay(300)
					shop.toast(`${product.count} ${product.unit_desc} x ${product.title} ${translate("im Warenkorb")}`, "info", false, "bottom")
					setLoading(false)
				}} />
		</div>
	</div>
}

function delay(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}


// WEBPACK FOOTER //
// ./src/theme/mags/components/Product/ProductListItem.js